import { useEffect } from 'react';
import { useInitCallIntelFilters } from '../filters/hooks/use-init-call-intel-filters';
import { useCallIntelLocations } from './use-call-intel-locations';
import { useCallIntelShallowStore } from './use-call-intel-store';
import { useLocationsMatch } from './use-locations-match';

/**
 * Hook to initialize Call Intelligence page state and filters.
 */
export const useInitCallIntel = () => {
  const { locations } = useCallIntelLocations();
  const { setLocationIds, resetStore } = useCallIntelShallowStore('setLocationIds', 'resetStore');

  // Initialize filters on mount
  useInitCallIntelFilters({ checkURLFilters: true });

  const areLocationsMatching = useLocationsMatch(locations);

  useEffect(() => {
    // Reset when location is switched
    const pickerLocationIds = Object.keys(locations);

    if (pickerLocationIds.length) {
      setLocationIds(pickerLocationIds);
    }

    if (pickerLocationIds.length && !areLocationsMatching) {
      resetStore();
    }
  }, [locations, areLocationsMatching, setLocationIds, resetStore]);
};
